<template>
  <div class="page-container appstore_wrap">
    <market-header tabs="apps" :disableSearch="true"></market-header>
    <div class="container">
      <el-row class="mt80">
        <el-col :span="16">
          <el-input
            placeholder="请输入内容"
            v-model="queryParam.query"
            @change="handleSearch"
            class="mg20 custom-btn-searchs"
          >
            <el-button slot="prepend" icon="el-icon-search">搜索</el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="searchKey" v-if="searchKeys">
            <span
              @click="() => searchKeyChange(key)"
              :class="getActiveSearch(key)"
              v-for="key in searchKeys"
              :key="key"
              >{{ key }}</span
            >
          </div>
        </el-col>
      </el-row>
      <div class="applist">
        <div class="applist-l">
          <div>
            <div class="catetory-top">
              <div class="nav-container">
                <div class="nav-drop-item">
                  <a class="nav-link">全部应用</a>
                </div>
              </div>
            </div>
            <div class="search">
              <div class="gradient-bj"></div>
              <dl class="product-class y-clear">
                <dt>应用标签</dt>
                <dd v-loading="categoryLoaing">
                  <a
                    v-for="cate in tags"
                    :class="getActiveCate(cate.tagName)"
                    :key="cate.tagID"
                    @click="() => setCategory(cate.tagName)"
                    >{{ cate.tagName }}</a
                  >
                </dd>
              </dl>
            </div>
          </div>
          <div class="quick-sort y-clear" data-spm="sort">
            <ul class="sort-bar">
              <li class="static">
                <span class="y-left">排序</span>
              </li>
              <li
                @click="changeOrder('')"
                :class="queryParam.order == '' && 'active'"
              >
                <span class="y-left">默认</span>
              </li>
              <li
                @click="changeOrder('updateTime-desc')"
                :class="queryParam.order.startsWith('updateTime') && 'active'"
              >
                <span class="y-left">更新时间</span>
                <span class="sort">
                  <i
                    @click="changeOrder('score-desc', 'upTime', 'up')"
                    :class="
                      activeMap.upTime === 'up'
                        ? 'sort-caret ascending activeAscending'
                        : 'sort-caret ascending '
                    "
                  ></i>
                  <i
                    @click="changeOrder('score-asc', 'upTime', 'drop')"
                    :class="
                      activeMap.upTime === 'drop'
                        ? 'sort-caret descending activeDescending'
                        : 'sort-caret descending '
                    "
                  ></i>
                </span>
              </li>
              <li
                @click="changeOrder('score-desc')"
                :class="queryParam.order.startsWith('score') && 'active'"
              >
                <span class="y-left">综合评分</span>
                <span class="sort">
                  <i
                    @click="changeOrder('score-desc', 'score', 'up')"
                    :class="
                      activeMap.score === 'up'
                        ? 'sort-caret ascending activeAscending'
                        : 'sort-caret ascending '
                    "
                  ></i>
                  <i
                    @click="changeOrder('score-asc', 'score', 'drop')"
                    :class="
                      activeMap.score === 'drop'
                        ? 'sort-caret descending activeDescending'
                        : 'sort-caret descending '
                    "
                  ></i>
                </span>
              </li>
            </ul>
            <div class="y-right y-mr-5 totalRecords">
              为您找到{{ total }}条结果
            </div>
          </div>

          <div class="product-list m-bg-white" v-loading="appLoaing">
            <ul v-if="apps && apps.length > 0" class="product-ul">
              <li v-for="app in apps" :key="app.appKeyID">
                <div class="view-img y-left">
                  <a target="_blank" :href="getAppURL(app)">
                    <img :src="app.appLogo || appLogoDef" :alt="app.appName" />
                  </a>
                </div>
                <div class="view-info y-left">
                  <h1 class="view-title">
                    <a target="_blank" :href="getAppURL(app)">
                      {{ app.appName }}
                    </a>
                  </h1>
                  <div class="line info" :title="app.appDesc">
                    {{ app.appDesc }}
                  </div>
                  <div class="line">
                    <span>商店：</span>
                    <a target="_blank" :href="getMarketURL(app)">
                      {{ app.marketName }}
                    </a>
                  </div>
                </div>
                <div class="view-desc y-left">
                  <div class="starts">
                    <div class="r-icon-star">
                      <el-rate disabled :value="rate(app)"></el-rate>
                    </div>
                  </div>
                </div>
                <div class="view-price y-right">
                  <div class="titles">
                    <span>
                      <span>{{ app.minPrice }}</span>
                      <i>元/{{ getUnitTime(app) }}</i>
                    </span>
                  </div>
                </div>
                <div class="y-clear"></div>
                <div class="product-tag y-clear">
                  <a
                    v-for="tag in app.appTags"
                    :key="tag"
                    :href="getMarketURL(app, tag)"
                    class="tags"
                    >{{ tag }}</a
                  >
                </div>
              </li>
            </ul>
            <template v-else>
              <no-data class="noData" size="180px" />
            </template>
            <ul class="pages-ul">
              <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="queryParam.page"
                :page-size="queryParam.pageSize"
                layout="prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <div class="backtop">
       <el-popover placement="left" trigger="hover">
          <img class="wechart" src="../../assets/images/wechart.png" alt="" />
          <p style="font-size: 12px; margin-bottom: 0px; margin-top:6px; text-align: center">扫一扫，邀你进群交流吧</p>
          <div slot="reference">
            <img src="../../assets/images/feedback.svg" alt="">
          </div>
        </el-popover>
    </div>
    <el-backtop style="right: 14px"></el-backtop>
  </div>
</template>
<script>
import {
  getAppCategory,
  getAppList,
  getHotSearchKeys,
  getHotTags
} from '@/api/index';
import { postAccessInfo } from '@/api/accessInfo';
export default {
  name: 'HotApp',
  components: {},
  data() {
    return {
      total: 0,
      apps: [],
      categoryLoaing: true,
      appLoaing: false,
      appLogoDef: require('../../assets/images/app_icon.png'),
      checkboxGroup3: ['上海'],
      searchKeys: ['物联网', '智能公交', 'IoT', '会议', '解决方案'],
      searchKey: '',
      categorys: [],
      queryParam: {
        page: 1,
        pageSize: 10,
        order: '',
        query: '',
        category: ''
      },
      activeMap: {
        upTime: 'drop',
        score: 'drop'
      },
      tags: []
    };
  },
  computed: {},
  created() {
    const initquery = this.$route.query.query;
    if (initquery) {
      this.queryParam.query = initquery;
    }
    this.loadHotTags();
    this.loadAppList();
    this.postAccessInfo();
    this.loadHotSearchKeys();
  },
  methods: {
    searchKeyChange(key) {
      this.queryParam.query = key;
      this.handleSearch(key);
    },
    postAccessInfo() {
      postAccessInfo({}).catch((err) => {});
    },
    changeOrder(order, type, sorting) {
      if (type) {
        this.activeMap[type] = sorting;
      }
      this.queryParam.order = order;
      this.loadAppList();
    },
    handleSearch(search) {
      this.queryParam.page = 1;
      this.loadAppList();
    },
    rate(app) {
      const rate = app.appScore / 50;
      return rate > 5 ? 5 : rate;
    },
    getActiveCate(cate) {
      if (cate == this.queryParam.tag) {
        return 'active';
      }
      return '';
    },
    getActiveSearch(key) {
      if (key == this.queryParam.query) {
        return 'active';
      }
      return '';
    },
    getMarketURL(app, tag) {
      if (tag) {
        return `/markets/${app.marketDomain}?tags=` + tag;
      }
      return `/markets/${app.marketDomain}`;
    },
    getAppURL(app) {
      return `/markets/${app.marketDomain}/apps/${app.appID}`;
    },
    getUnitTime(app) {
      const unitShow = { month: '月', year: '年', quarter: '季度', week: '周' };
      return unitShow[app.minCycle];
    },
    setCategory(item) {
      if (this.queryParam.tag == item) {
        this.queryParam.tag = '';
      } else {
        this.queryParam.tag = item;
      }
      this.loadAppList();
    },
    loadAppCategory() {
      this.categoryLoaing = true;
      getAppCategory()
        .then((re) => {
          this.categorys = re;
          this.categoryLoaing = false;
        })
        .catch(() => {
          this.categoryLoaing = false;
        });
    },
    loadAppList() {
      if (this.appLoaing) {
        return;
      }
      this.appLoaing = true;
      getAppList(this.queryParam)
        .then((re) => {
          this.apps = re.apps;
          this.total = re.total;
          this.appLoaing = false;
        })
        .catch(() => {
          this.appLoaing = false;
        });
    },
    loadHotSearchKeys() {
      getHotSearchKeys({ limit: 5 })
        .then((re) => {
          this.searchKeys = re;
          this.categoryLoaing = false;
        })
        .catch((err) => {
          this.categoryLoaing = false;
        });
    },
    loadHotTags() {
      getHotTags({ limit: 20 }).then((re) => {
        this.tags = re;
      });
    },
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.loadAppList();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.backtop{
  position: fixed;
  bottom: 100px;
  right: 14px;
  z-index: 999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
}
.wechart {
    width: 140px;
    height: 140px;
  }
.y-clear:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
}
.y-clear {
  zoom: 1;
}
.container {
  width: 1200px;
  margin: 0 auto;
  justify-content: inherit !important;
  min-height: calc(100vh - 114px);
}
.mt80 {
  margin-top: 80px;
}
.applist {
  display: flex;
}
.applist-l {
  width: 100%;
}
.applist-r {
  width: 230px;
  .titles {
    height: 48px;
    font-family: MicrosoftYaHei;
    color: #666;
    line-height: 48px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(84, 88, 90, 1);
  }
  .cr-list {
    width: 100%;
    .cr-item {
      width: 100%;
      background: #fff;
      border: 1px solid #e5e5e5;
      margin-bottom: 13px;
      transition: 0.2s;
      a {
        display: block;
        width: 100%;
        text-decoration: none;
        .logo {
          height: 90px;
          position: relative;
          img {
            width: 100%;
            height: 90px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate3d(-50%, -50%, 0);
          }
        }
        .btm {
          padding: 12px 15px 15px;
          box-sizing: border-box;
          .name {
            font-family: MicrosoftYaHei;
            font-size: 16px;
            color: #181818;
            line-height: 24px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            max-height: 48px;
            transition: 0.2s;
          }
          .desc {
            font-family: MicrosoftYaHei;
            font-size: 12px;
            max-height: 38px;
            color: #666;
            line-height: 20px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
  }
}

.nav-container .nav-drop-item .nav-link {
  display: inline-block;
  line-height: 48px;
  box-sizing: border-box;
  text-decoration: none;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(84, 88, 90, 1);
}
.search {
  padding: 0;
  background: #fff;
  border: 1px solid #e1e1e1;
  position: relative;
  .gradient-bj {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100px;
    background-repeat: repeat-x;
    background-image: linear-gradient(44deg, #005eba, #005eba);
  }

  .product-class {
    line-height: 16px;
    min-height: 40px;
    display: table;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 0px;
    dd,
    dt {
      display: table-cell;
      vertical-align: middle;
    }
    dt {
      width: 101px;
      font-size: 12px;
      text-align: center;
      box-sizing: border-box;
      color: #fff;
    }

    dd {
      padding: 5px 22px;
      a {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(84, 88, 90, 1);
        line-height: 26px;
        transition: 0.2s;
        text-decoration: none;
        cursor: pointer;
        margin-right: 40px;
        float: left;
        &:hover {
          color: #005eba;
        }
        &.active {
          color: #005eba;
        }
      }
    }
  }

  .ul-list {
    margin: 0;
    position: relative;
    .m-pro-item {
      width: 100%;
      border-bottom: 1px solid hsla(0, 0%, 72%, 0.4);
      overflow: hidden;
      display: table;
      min-height: 40px;
      .limit-height,
      .titles {
        display: table-cell;
        vertical-align: middle;
        box-sizing: border-box;
      }
      .titles {
        text-align: left;
        width: 100px;
        color: #fff;
        padding-left: 20px;
      }
      .limit-height {
        height: 100%;
        padding: 5px 22px;
      }
      .custom-btn.active {
        color: #005eba;
      }
      .custom-btn {
        &:hover {
          color: #005eba;
          text-decoration: underline;
        }
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #54585a;
        line-height: 26px;
        margin-right: 40px;
        transition: 0.2s;
        text-decoration: none;
        cursor: pointer;
        float: left;
      }
    }
  }
}

.quick-sort {
  background: #ebebeb;
  margin-top: 16px;
  margin-bottom: 16px;
  .sort-bar {
    padding: 0;
    margin: 0;
    height: 100%;
    li {
      float: left;
      border-right: 1px solid rgba(174, 206, 255, 0.36);
      padding: 0 28px;
      height: 100%;
      line-height: 45px;
      user-select: none;
      &:hover {
        cursor: pointer;
        .y-left {
          color: #005eba;
        }
      }
      .sort {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        height: 34px;
        width: 24px;
        vertical-align: middle;
        cursor: pointer;
        overflow: initial;
        position: relative;
        .sort-caret {
          width: 0;
          height: 0;
          border: 5px solid transparent;
          position: absolute;
          left: 7px;
        }
        .ascending {
          border-bottom-color: #c0c4cc;
          top: 5px;
        }
        .descending {
          border-top-color: #c0c4cc;
          bottom: 7px;
        }
        .activeDescending {
          border-top-color: #005eba;
        }
        .activeAscending {
          border-bottom-color: #005eba;
        }
      }
    }
    .active {
      background: #fff;
      span {
        color: #005eba;
      }
    }
  }
  .totalRecords {
    padding: 12px 24px;
  }
}
.y-right {
  float: right !important;
}
.y-left {
  font-family: PingFangSC-Regular, PingFang SC;
  float: left !important;
  color: #666;
}
.y-left,
.y-right {
  display: inline;
}
.down,
.up {
  width: 100%;
  height: 100%;
  background-size: 12px 16px;
  background-repeat: none;
}

.product-list {
  margin-top: 10px;
  margin-bottom: 40px;
  .product-ul li {
    padding: 24px 55px 20px 40px;
    margin-bottom: 12px;
    background: #fff;
    position: relative;
    min-height: 165px;
    box-sizing: border-box;
    .view-img {
      max-height: 75px;
      overflow: hidden;
      img {
        width: 75px;
      }
    }
    .view-info {
      margin-left: 40px;
      width: 67.1%;
      padding-bottom: 8px;
      border-bottom: 1px solid #f0f0f0;
      margin-bottom: 10px;
      transition: 0.2s;
      a {
        color: #005eba;
      }
      .titles {
        color: #005eba;
        font-size: 28px;
        font-family: PingFangSC-Semibold;
      }
      .informationtag span {
        float: left;
        white-space: nowrap;
        margin-right: 20px;
      }
      .informationtag span:last-child {
        margin: 0;
      }
      .informationtag:after {
        clear: both;
      }
      .view-title {
        margin: 0;
        margin-bottom: 5px;
        line-height: 0;
        a {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #373d41;
          line-height: 24px;
          overflow: hidden;
          max-height: 72px;
        }
      }
      .info {
        color: #333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 10px;
      }
      .line {
        line-height: 18px;
        color: #373d41;
      }
    }
    .view-desc {
      width: 160px;
      position: absolute;
      left: 0;
      bottom: 20px;
      text-align: center;
      .starts {
        font-size: 0;
        margin-bottom: 8px;
        ::v-deep .r-icon-star {
          .el-rate__icon {
            margin-right: 0;
          }
        }
      }
    }
    .product-tag {
      margin-left: 110px;
      .tags {
        margin-right: 5px;
        padding: 2px 5px;
        border: 1px solid #fff;
        color: #54585a;
        text-decoration: none;
      }
    }
    .view-price {
      margin-top: 35px;
      .titles {
        color: #005eba;
        font-size: 40px;
        font-family: PingFangSC-Semibold;
        i {
          font-style: normal;
          font-size: 18px;
        }
      }
    }
  }
}
.product-list .product-ul li .view-info .informationtag:after,
.product-list .product-ul li .view-info .informationtag:before {
  content: '';
  display: table;
}

.pages-ul {
  margin: 0 auto;
  padding: 24px 0;
  text-align: center;
}
::v-deep .custom-btn-searchs {
  .el-input__inner,
  .el-input-group__prepend {
    background: rgba(249, 249, 249, 1);
  }
  .el-input__inner:hover {
    border-color: #dcdfe6;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #dcdfe6;
  }
  .el-input__inner {
    border-left: 0;
  }
  .el-input-group__append {
    background: #ffffff;
  }
}
::v-deep .custom-btn-checkboxs {
  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    color: rgba(0, 94, 186, 1);
    background: #ffffff;
  }
  .el-checkbox-button__inner {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(84, 88, 90, 1);
    border: none !important;
    &:hover {
      color: rgba(0, 94, 186, 1) !important;
    }
  }
  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    box-shadow: none !important;
  }
}
.searchKey {
  background: #fff;
  height: 40px;
  margin: 20px 0;
  span {
    padding: 0 16px;
    line-height: 40px;
    cursor: pointer;
  }
  .active {
    color: #005eba;
  }
}
.mg20 {
  margin: 20px 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/index/appList.vue